import { SearchQuery } from "@graphqlTypes";

type WpSearchResult = SearchQuery["search"]["nodes"][number];

export type MergedResult =
  | { type: "wp"; data: WpSearchResult }
  | { type: "shop"; data: ShopifyCarouselProduct };

export function interleaveResults(
  wpResults: WpSearchResult[],
  shopResults: ShopifyCarouselProduct[]
): MergedResult[] {
  if (!wpResults.length && !shopResults.length) return [];
  if (!wpResults.length) return shopResults.map((s) => ({ type: "shop", data: s }));
  if (!shopResults.length) return wpResults.map((w) => ({ type: "wp", data: w }));

  const merged: MergedResult[] = [];
  let wpIndex = 0;
  let shopIndex = 0;

  // 3 organic, 1 shop, 3 organic, 1 shop (8 per page)
  while (wpIndex < wpResults.length || shopIndex < shopResults.length) {
    // first batch of 3 organic
    for (let i = 0; i < 3 && wpIndex < wpResults.length; i++) {
      merged.push({ type: "wp", data: wpResults[wpIndex++] });
    }

    // first shop item (position 4)
    if (shopIndex < shopResults.length) {
      merged.push({ type: "shop", data: shopResults[shopIndex++] });
    }

    // second batch of 3 organic
    for (let i = 0; i < 3 && wpIndex < wpResults.length; i++) {
      merged.push({ type: "wp", data: wpResults[wpIndex++] });
    }

    // second shop item (position 8)
    if (shopIndex < shopResults.length) {
      merged.push({ type: "shop", data: shopResults[shopIndex++] });
    }

    // xxit if we've exhausted both arrays
    if (wpIndex >= wpResults.length && shopIndex >= shopResults.length) break;
  }

  return merged;
}

export function interleaveTrayResults(
  wpResults: WpSearchResult[],
  shopResults: ShopifyCarouselProduct[]
): MergedResult[] {
  if (!wpResults.length && !shopResults.length) return [];

  if (!wpResults.length) {
    return shopResults.slice(0, 4).map((s) => ({ type: "shop", data: s }));
  }

  if (!shopResults.length) {
    return wpResults.slice(0, 4).map((w) => ({ type: "wp", data: w }));
  }

  const wp = wpResults.slice(0, 3).map((w): MergedResult => ({ type: "wp", data: w }));
  const shop: MergedResult = { type: "shop", data: shopResults[0] };
  return [...wp, shop];
}
